import React, { useEffect, useState, useRef } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import Detail from "../../components/Detail";
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdbreact";
import SecondaryButton from "../../components/Button/SecondaryButton";
import Loading from "../../components/Loading";
import Jumbotron from "../../components/Jumbotron";
import "../HistoryDetail/HistoryDetail.css";
import axiosGet from "../../helpers/axiosGet";
import StatusPill from "../../components/StatusPill";
import constants from "../../constants";

export default function PublicDetail() {
  const scroll = useRef(null);
  const executeScroll = () => scroll.current.scrollIntoView();
  const history = useHistory();

  const { uniqKey } = useParams();

  useEffect(() => {
    sessionStorage.setItem("isPublic", true);

    setTimeout(() => {
      axiosGet({
        url: `${constants.DEFAULT_URL_PUBLIC}/v2/open/personal-accident/policy/uniq-key/${uniqKey}`,
        callback: (res) => {
          setLoading(false);
          setDetail(res.data);
          setFiles([
            // {
            //   title: "Identify File",
            //   type: "identifyFile",
            //   value: res.data.files.identifyFile,
            //   fileName: `${res.data.policyNumber}-Identity`,
            // },
            {
              title: "Invoice",
              type: "invoice",
              value: res.data.files.invoice,
              fileName: `${res.data.policyNumber}-Invoice`,
            },
            {
              title: "Policy",
              type: "policy",
              value: res.data.files.policy,
              fileName: `${res.data.policyNumber}`,
            },
          ]);
        },
        errorCallback: (err) => {
          console.log(err);
          history.push("/404");
          setLoading(false);
        },
      });
    }, 2000);
  }, [history, uniqKey]);

  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState({});
  const [files, setFiles] = useState([]);

  return (
    <>
      <Jumbotron />

      <section className="create-main-content" ref={scroll}>
        <div className="text-center">
          <h3 className="font-weight-bold">POLICY DETAIL</h3>
          <p className="mb-1">SCHEDULE PERSONAL ACCIDENT CO-PRODUCT</p>
          <hr className="create-divider-primary create-divider-big" />
        </div>
        <div className="mt-5">
          <p className="mb-1">Pembelian Detail</p>
          <hr className="create-divider-primary create-divider-small" />
        </div>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="mt-3">
              <MDBContainer>
                <MDBRow className="status-justify">
                  <StatusPill value={detail.status} />
                </MDBRow>
              </MDBContainer>
            </div>

            <Detail data={detail} summary />

            <div className="mt-5">
              <MDBRow className="create-row-gap">
                {files.length &&
                  files.map((file) => {
                    return file.value ? (
                      <DownloadFiles
                        id={detail.id}
                        file={file}
                        key={file.title}
                        uniqKey={uniqKey}
                      />
                    ) : null;
                  })}
                <DownloadFiles
                  uniqKey={uniqKey}
                  id={detail.id}
                  file={{
                    title: `${detail.insuranceCode}`,
                    type: `clause`,
                    fileName: `${detail.insuranceCode}-Clause`,
                  }}
                />
              </MDBRow>
            </div>

            <MDBContainer className="create-button-container">
              <MDBRow>
                <Link to="/history" onClick={executeScroll}>
                  <SecondaryButton text="Back" />
                </Link>
              </MDBRow>
            </MDBContainer>
          </>
        )}
      </section>
    </>
  );
}

const DownloadFiles = ({ file, clause, uniqKey }) => {
  const { title, type, fileName, url } = file;

  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);
    axiosGet({
      url: `/v2/open/personal-accident/download/uniq-key/${uniqKey}/download-file/${type}`,
      responseType: "blob",
      callback: (res) => {
        setLoading(false);
      },
      errorCallback: (res) => {
        setLoading(false);

        let ext = "";
        if (res.type === "image/png") {
          ext = "png";
        } else if (res.type === "image/jpeg") {
          ext = "jpg";
        } else {
          ext = "pdf";
        }

        const blob = new Blob([res]);
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", `${fileName}.${ext}`);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
    });
  };

  return (
    <MDBCol md="6" lg="4">
      <div className="border rounded bg-white px-4 py-2 position-relative overflow-hidden">
        <div className="create-bg-ellipse"></div>
        <MDBRow>
          <MDBCol size="4" middle>
            {clause ? (
              <a href={url} download>
                <MDBIcon
                  icon="cloud-download-alt"
                  size="2x"
                  className="create-color-primary"
                />
              </a>
            ) : loading ? (
              <div
                className="spinner-border create-color-primary"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleDownload(type)}
              >
                <MDBIcon
                  icon="cloud-download-alt"
                  size="2x"
                  className="create-color-primary"
                />
              </div>
            )}
          </MDBCol>

          <MDBCol size="8">
            <p className="font-weight-bolder mb-1">{`Download ${title}`}</p>
            <p className="create-text-small font-weight-bolder mb-0">
              {fileName}
            </p>
          </MDBCol>
        </MDBRow>
      </div>
    </MDBCol>
  );
};
